import CategoryIcon from "../assets/image svg/party.svg";
import GenreIcon from "../assets/image svg/Music.svg";
import UserIcon from "../assets/image svg/User.svg";
import VenueIcon from "../assets/image svg/Locatie.svg";
// import PriceIcon from "../assets/image svg/Price.svg";

import ArrowDownIcon from "../assets/image svg/chevron down.svg";
import LocationIcon from "../assets/image svg/Locatie.svg";
import {
  Button,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Portal,
  RangeSlider,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  Box,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  Checkbox,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "../supabaseClient";
import Icon from "./Icon";
import DateRangePicker from "./DateRangePicker";
import { trackFilterAnalytics } from "../utils/visitorTracking";
import { useSelector } from "react-redux";
import { selectUser } from "../slices/userReducer";

// Enhanced City Filter Component
const EnhancedCityFilter = ({
  filters,
  selectedCities,
  onCityChange,
  updateFilters,
  t,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [cities, setCities] = useState([]);
  const [citiesByCountry, setCitiesByCountry] = useState({});

  // Fetch cities and organize by country
  useEffect(() => {
    supabase
      .from("City")
      .select("*")
      .then(({ data, error }) => {
        if (error) {
          console.error(error);
        } else {
          // Group cities by country with better fallback logic
          const cityGroups = {};
          data.forEach((city) => {
            // Use a more comprehensive fallback system
            let country = "Netherlands"; // Default country for this app

            // If the database has a country field, use it
            if (city.country && city.country.trim() !== "") {
              country = city.country;
            } else {
              // Simple city-to-country mapping for common cases
              const cityName = city.name.toLowerCase();
              if (
                cityName.includes("london") ||
                cityName.includes("manchester") ||
                cityName.includes("birmingham")
              ) {
                country = "United Kingdom";
              } else if (
                cityName.includes("paris") ||
                cityName.includes("lyon") ||
                cityName.includes("marseille")
              ) {
                country = "France";
              } else if (
                cityName.includes("berlin") ||
                cityName.includes("munich") ||
                cityName.includes("hamburg")
              ) {
                country = "Germany";
              } else if (
                cityName.includes("ibiza") ||
                cityName.includes("barcelona") ||
                cityName.includes("valencia")
              ) {
                country = "Spain";
              } else if (
                cityName.includes("rome") ||
                cityName.includes("milan") ||
                cityName.includes("naples")
              ) {
                country = "Italy";
              } else if (
                cityName.includes("amsterdam") ||
                cityName.includes("rotterdam") ||
                cityName.includes("utrecht") ||
                cityName.includes("eindhoven") ||
                cityName.includes("tilburg") ||
                cityName.includes("groningen") ||
                cityName.includes("breda") ||
                cityName.includes("nijmegen") ||
                cityName.includes("enschede") ||
                cityName.includes("haarlem") ||
                cityName.includes("almere") ||
                cityName.includes("apeldoorn") ||
                cityName.includes("arnhem") ||
                cityName.includes("den haag") ||
                cityName.includes("s-gravenhage") ||
                cityName.includes("the hague")
              ) {
                country = "Netherlands";
              } else if (
                cityName.includes("canggu") ||
                cityName.includes("uluwatu") ||
                cityName.includes("seminyak") ||
                cityName.includes("ubud") ||
                cityName.includes("jakarta") ||
                cityName.includes("bali") ||
                cityName.includes("denpasar")
              ) {
                country = "Indonesia";
              }
            }

            if (!cityGroups[country]) {
              cityGroups[country] = [];
            }
            cityGroups[country].push(city.name);
          });

          // Sort cities within each country alphabetically
          Object.keys(cityGroups).forEach((country) => {
            cityGroups[country].sort();
          });

          setCitiesByCountry(cityGroups);
          setCities(data.map((city) => city.name));
        }
      });
  }, []);

  // Helper function to check if all cities in a country are selected
  const isCountryFullySelected = (country) => {
    const countryCities = citiesByCountry[country] || [];
    return (
      countryCities.length > 0 &&
      countryCities.every((city) => selectedCities?.includes(city))
    );
  };

  // Helper function to check if some (but not all) cities in a country are selected
  const isCountryPartiallySelected = (country) => {
    const countryCities = citiesByCountry[country] || [];
    const selectedInCountry = countryCities.filter((city) =>
      selectedCities?.includes(city)
    );
    return (
      selectedInCountry.length > 0 &&
      selectedInCountry.length < countryCities.length
    );
  };

  // Handle country-level selection/deselection - Standard checkbox behavior
  const handleCountryToggle = (country) => {
    const countryCities = citiesByCountry[country] || [];
    const isFullySelected = isCountryFullySelected(country);

    let newSelectedCities = selectedCities || [];

    if (isFullySelected) {
      // Checkbox is checked → Deselect all cities in this country
      newSelectedCities = newSelectedCities.filter(
        (city) => !countryCities.includes(city)
      );
    } else {
      // Checkbox is unchecked or indeterminate → Select all cities in this country
      // Remove any existing cities from this country first, then add all cities
      const citiesNotInCountry = newSelectedCities.filter(
        (city) => !countryCities.includes(city)
      );
      newSelectedCities = [...citiesNotInCountry, ...countryCities];
    }

    onCityChange(newSelectedCities);
    updateFilters(newSelectedCities, "cities");
  };

  // Filter cities based on search term
  const filteredCitiesByCountry = Object.keys(citiesByCountry).reduce(
    (acc, country) => {
      const filteredCities = citiesByCountry[country].filter((city) =>
        city.toLowerCase().includes(searchTerm.toLowerCase())
      );
      if (filteredCities.length > 0) {
        acc[country] = filteredCities;
      }
      return acc;
    },
    {}
  );

  return (
    <div className="filter-date mr-5 side">
      <Menu
        placement="bottom-start"
        strategy="fixed"
        gutter={0}
        offset={[0, 4]}
        matchWidth={false}
        closeOnSelect={false}
      >
        <MenuButton
          as={Button}
          className="bg-[#1D1726] !border-transparent !rounded-[10px] btn btn-dropdown dropdown-toggle"
          leftIcon={<img src={LocationIcon} alt="locatie" />}
          rightIcon={<img src={ArrowDownIcon} alt="arrow down" />}
        >
          <span className="selectedOption" id="button1Text">
            {selectedCities?.length === 1 &&
            !selectedCities[0]?.toLowerCase().includes("all_cities")
              ? selectedCities[0]
              : selectedCities?.length > 1 &&
                !selectedCities.some((city) =>
                  city?.toLowerCase().includes("all_cities")
                )
              ? `${selectedCities.length} ${t("cities_selected")}`
              : t("all_cities")}
          </span>
        </MenuButton>
        <Portal>
          <MenuList
            className="menu-list"
            zIndex={99999999999999}
            position="fixed"
            width="250px"
            padding="0"
            style={{
              transform: "translateZ(0)",
              backgroundColor: "white",
              border: "1px solid #d1d5db",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            }}
          >
            {/* Search Bar */}
            <Box padding="12px" borderBottom="1px solid #e5e7eb">
              <InputGroup>
                <InputLeftElement
                  pointerEvents="none"
                  paddingLeft="10px"
                  height="40px"
                  display="flex"
                  alignItems="center"
                >
                  <Icon
                    icon="heroicons:magnifying-glass"
                    className="w-[16px] h-[16px] text-gray-400"
                  />
                </InputLeftElement>
                <Input
                  placeholder={t("search_cities") || "Search cities..."}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  bg="white"
                  border="1px solid #d1d5db"
                  borderRadius="8px"
                  color="black"
                  _placeholder={{ color: "#6b7280" }}
                  _focus={{
                    borderColor: "#7721E5",
                    boxShadow: "0 0 0 1px #7721E5",
                    outline: "none",
                  }}
                  fontSize="14px"
                  height="40px"
                  width="100%"
                  paddingLeft="30px"
                  autoComplete="off"
                  inputMode="search"
                  autoFocus={false}
                  onFocus={(e) => {
                    // Ensure mobile keyboard appears
                    if (window.innerWidth <= 768) {
                      e.target.setAttribute("autocomplete", "off");
                      e.target.setAttribute("autocorrect", "off");
                      e.target.setAttribute("autocapitalize", "off");
                      e.target.setAttribute("spellcheck", "false");

                      // Scroll to input on mobile
                      setTimeout(() => {
                        e.target.scrollIntoView({
                          behavior: "smooth",
                          block: "center",
                          inline: "nearest",
                        });
                      }, 300);
                    }
                  }}
                  style={{
                    WebkitAppearance: "none",
                    WebkitUserSelect: "text",
                    fontSize: window.innerWidth <= 768 ? "16px" : "14px", // Prevent zoom on iOS
                  }}
                />
              </InputGroup>
            </Box>

            {/* Cities organized by country */}
            <Box>
              {Object.keys(filteredCitiesByCountry).length > 0 ? (
                Object.keys(filteredCitiesByCountry)
                  .sort((a, b) => {
                    // Netherlands first, then alphabetical
                    if (a === "Netherlands") return -1;
                    if (b === "Netherlands") return 1;
                    return a.localeCompare(b);
                  })
                  .map((country) => (
                    <Box key={country}>
                      {/* Country Header - Clickable with Checkbox */}
                      <Box
                        padding="8px 8px"
                        backgroundColor="transparent"
                        cursor="pointer"
                        _hover={{ backgroundColor: "#f9f9f9" }}
                        onClick={() => handleCountryToggle(country)}
                        transition="background-color 0.2s"
                        display="flex"
                        className="flex items-center gap-[6px]"
                        alignItems="center"
                      >
                        <input
                          type="checkbox"
                          checked={isCountryFullySelected(country)}
                          onChange={() => handleCountryToggle(country)}
                          onClick={(e) => e.stopPropagation()} // Prevent double triggering
                          className="!rounded-[4px] outline-none !w-[16px] !h-[16px] !accent-purple-500"
                        />
                        <Text
                          fontSize="13px"
                          fontWeight="bold"
                          marginTop="2px"
                          color={
                            isCountryFullySelected(country)
                              ? "#7721E5"
                              : "#6b7280"
                          }
                          textTransform="uppercase"
                          lineHeight="13px"
                          letterSpacing="0.5px"
                          flex="1"
                        >
                          {country}
                        </Text>
                      </Box>

                      {/* Cities in this country */}
                      <MenuOptionGroup
                        type="checkbox"
                        value={selectedCities}
                        onChange={(values) => {
                          onCityChange(values);
                          updateFilters(values, "cities");
                        }}
                      >
                        {filteredCitiesByCountry[country].map((city) => (
                          <MenuItemOption
                            key={city}
                            value={city}
                            className="!bg-transparent hover:!bg-gray-50 !mx-0 !px-4 !py-3 !border-none !text-black transition-colors duration-200"
                            style={{
                              backgroundColor: selectedCities?.includes(city)
                                ? "#f3f4f6"
                                : "transparent",
                              borderRadius: "0",
                              margin: "0",
                              fontSize: "14px",
                              fontWeight: "400",
                              color: selectedCities?.includes(city)
                                ? "#7721E5"
                                : "black",
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="space-between"
                              width="100%"
                            >
                              <Text
                                color={
                                  selectedCities?.includes(city)
                                    ? "#7721E5"
                                    : "black"
                                }
                              >
                                {city}
                              </Text>
                            </Box>
                          </MenuItemOption>
                        ))}
                      </MenuOptionGroup>
                    </Box>
                  ))
              ) : (
                <Box padding="20px" textAlign="center" color="#6b7280">
                  <Text fontSize="14px">
                    {t("no_cities_found") || "No cities found"}
                  </Text>
                </Box>
              )}
            </Box>
          </MenuList>
        </Portal>
      </Menu>
    </div>
  );
};

const DiscoverEvent = ({ filters, setFilters, city, genres, changeCity }) => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);

  // Fix localStorage "All_cities" issue
  useEffect(() => {
    const storedCity = localStorage.getItem("city");
    if (storedCity === "All_cities") {
      localStorage.setItem("city", "all_cities");
    }
  }, []);

  // Initialize selectedCities with filters.cities if it exists
  const [selectedCities, setSelectedCities] = useState(filters.cities || []);

  // Add state for selected venues
  const [selectedVenues, setSelectedVenues] = useState(filters.venues || []);

  // Add state for price range
  const [priceRange, setPriceRange] = useState(filters.priceRange || [0, 100]);

  // Add this state to track slider range based on currency
  const [sliderConfig, setSliderConfig] = useState({
    min: 0,
    max: 100,
    step: 5,
  });

  // Update selectedCities when filters.cities changes
  useEffect(() => {
    // Filter out any "All_cities" values when setting from filters
    const filteredCities = (filters.cities || []).filter(
      (city) => !city?.toLowerCase().includes("all_cities")
    );
    setSelectedCities(filteredCities);
  }, [filters.cities]);

  // Update selectedVenues when filters.venues changes
  useEffect(() => {
    setSelectedVenues(filters.venues || []);
  }, [filters.venues]);

  // Update priceRange when filters.priceRange changes
  useEffect(() => {
    setPriceRange(filters.priceRange || [0, 100]);
  }, [filters.priceRange]);

  // Update slider config when currency changes
  useEffect(() => {
    if (filters.currency === "Rp") {
      setSliderConfig({
        min: 0,
        max: 2000000,
        step: 50000,
      });
      // If current price range is using the default EUR scale, reset to IDR scale
      if (priceRange[1] === 100) {
        setPriceRange([0, 2000000]);
        updateFilters([0, 2000000], "priceRange");
      }
    } else {
      setSliderConfig({
        min: 0,
        max: 100,
        step: 5,
      });
      // If switching from IDR to another currency and using IDR scale, reset to default
      if (priceRange[1] > 1000) {
        setPriceRange([0, 100]);
        updateFilters([0, 100], "priceRange");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.currency]);

  const filterMenus = {
    datum: [
      t("today"),
      t("tomorrow"),
      t("this_week"),
      t("next_week"),
      t("this_month"),
      t("all_dates"),
    ],
    categorie: [
      t("day_event"),
      t("night_event"),
      t("festival"),
      t("all_events"),
    ],
    leeftijd: ["18+", "21+", "23+", t("all_ages")],
  };

  // const genreList = filterMenus.genre;
  const genreList = genres;
  const [selectedGenres, setSelectedGenres] = useState([]);

  const [cities, setCities] = useState([]);
  const [venues, setVenues] = useState([]);

  // Check if genres contains data, and if so, set it as the initial state
  useEffect(() => {
    if (genres && genres.length > 0) {
      setSelectedGenres(filters.genre || []);
    }
  }, [genres, filters.genre]);

  // Load filters from localStorage on component mount
  useEffect(() => {
    // Only load from localStorage if user has set filters before
    // and we're not using token default filters
    if (localStorage.getItem("userSetFilters") === "true") {
      const savedFilters = localStorage.getItem("eventFilters");
      if (savedFilters) {
        try {
          const parsedFilters = JSON.parse(savedFilters);

          // Update parent component's filters with saved values
          setFilters((prevFilters) => ({
            ...prevFilters,
            ...parsedFilters,
          }));

          // Update local state
          if (parsedFilters.genre) {
            setSelectedGenres(parsedFilters.genre);
          }
          if (parsedFilters.cities) {
            setSelectedCities(parsedFilters.cities);
          }
          if (parsedFilters.venues) {
            setSelectedVenues(parsedFilters.venues);
          }
          if (parsedFilters.priceRange) {
            setPriceRange(parsedFilters.priceRange);
          }
        } catch (error) {
          console.error("Error parsing saved filters:", error);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Save filters to localStorage when they change
  useEffect(() => {
    // Only save if we have valid filters and user has interacted with filters
    if (
      filters &&
      Object.keys(filters).length > 0 &&
      localStorage.getItem("userSetFilters") === "true"
    ) {
      localStorage.setItem("eventFilters", JSON.stringify(filters));
    }
  }, [filters]);

  const genreChange = (selectedItems) => {
    setSelectedGenres(selectedItems);
    updateFilters(selectedItems, "genre");
  };

  const updateFilters = (item, category) => {
    // Mark that user has set their own filters
    localStorage.setItem("userSetFilters", "true");

    // Map filter categories to PageEvent filter values
    const filterTypeMapping = {
      cities: "CITY",
      priceRange: "PRICE",
      datum: "DATE",
      dateRange: "DATE",
      venues: "VENUE",
      categorie: "EVENT_TYPE",
      genre: "GENRE",
      leeftijd: "AGE",
      currency: "PRICE", // Currency changes affect price filtering
    };

    // Track filter analytics
    const filterType = filterTypeMapping[category];
    if (filterType && category !== "dateRange") { // Don't track dateRange separately as it's tracked with datum
      trackFilterAnalytics(filterType, user?.id || null);
    }

    setFilters((prev) => {
      return { ...prev, [category]: item };
    });
  };

  // Handle city selection change
  const handleCityChange = (values) => {
    // Filter out any "All_cities" values and normalize the array
    const filteredValues = values.filter(
      (value) => !value?.toLowerCase().includes("all_cities")
    );

    setSelectedCities(filteredValues);
    if (filteredValues.length > 0) {
      changeCity(filteredValues[0]); // Set first selected city as current
    } else {
      changeCity("all_cities"); // Reset to all cities if none selected
    }

    // Track city filter analytics
    trackFilterAnalytics("CITY", user?.id || null);
  };

  useEffect(() => {
    // Fetch venues
    supabase
      .from("Venue")
      .select("*")
      .then(({ data, error }) => {
        if (error) {
          console.error(error);
        } else {
          setVenues(data.map((venue) => venue.name));
        }
      });
  }, []);

  useEffect(() => {
    // Force hardware acceleration for Safari on iOS
    const menuLists = document.querySelectorAll(".menu-list");
    menuLists.forEach((menu) => {
      menu.style.transform = "translateZ(0)";
      menu.style.webkitTransform = "translateZ(0)";
      menu.style.backfaceVisibility = "hidden";
      menu.style.webkitBackfaceVisibility = "hidden";
    });
  }, []);

  // Format price display based on currency
  const formatPrice = (price) => {
    if (filters.currency === "Rp") {
      // Format large numbers with commas for thousands
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return price;
  };

  return (
    <div className="relative flex justify-start items-center gap-3 px-[15px] max-lg:pb-2 max-lg:w-full max-lg:overflow-x-auto max-lg:scrollbar-hide">
      {/* Enhanced City Filter */}
      <EnhancedCityFilter
        filters={filters}
        selectedCities={selectedCities}
        onCityChange={handleCityChange}
        updateFilters={updateFilters}
        t={t}
      />

      {/* Venue Filter */}
      <div className="filter-venue mr-5 side">
        <Menu
          placement="bottom"
          strategy="fixed"
          gutter={0}
          offset={[0, 4]}
          matchWidth={true}
        >
          <MenuButton
            as={Button}
            className="bg-[#1D1726] !border-transparent !rounded-[10px] btn btn-dropdown dropdown-toggle"
            leftIcon={<img src={VenueIcon} alt="venue" />}
            rightIcon={<img src={ArrowDownIcon} alt="arrow down" />}
          >
            <span className="selectedOption" id="button1Text">
              {filters.venues?.length === 1
                ? filters.venues[0]
                : filters.venues?.length > 1
                ? `${filters.venues.length} ${t("venues_selected") || "venues"}`
                : t("all_venues") || "All venues"}
            </span>
          </MenuButton>
          <Portal>
            <MenuList
              className="menu-list"
              zIndex={99999999999999}
              position="fixed"
              width="auto"
              minWidth="150px"
              maxWidth="250px"
              maxHeight="500px"
              overflowY="auto"
              borderRadius="4px"
              style={{
                transform: "translateZ(0)",
              }}
            >
              <MenuOptionGroup
                type="checkbox"
                value={selectedVenues}
                onChange={(values) => {
                  setSelectedVenues(values);
                  updateFilters(values, "venues");
                }}
              >
                {venues.map((venue, index) => (
                  <MenuItemOption
                    key={index}
                    value={venue}
                    className="hover:bg-[#AD7AEF] text-white truncate"
                  >
                    {venue}
                  </MenuItemOption>
                ))}
              </MenuOptionGroup>
            </MenuList>
          </Portal>
        </Menu>
      </div>

      {/* Price Filter with Currency Selection */}
      <div className="filter-price mr-5 side">
        <Menu
          placement="bottom"
          strategy="fixed"
          gutter={0}
          offset={[0, 4]}
          matchWidth={true}
          closeOnSelect={false}
        >
          <MenuButton
            as={Button}
            className="bg-[#1D1726] !border-transparent !rounded-[10px] btn btn-dropdown dropdown-toggle"
            leftIcon={
              <Icon
                icon="hugeicons:coins-euro"
                className="w-[20px] h-[20px] text-[#ccc]"
              />
            }
            rightIcon={<img src={ArrowDownIcon} alt="arrow down" />}
          >
            <span className="selectedOption" id="button1Text">
              {priceRange[0] === 0 && priceRange[1] === 100
                ? t("all_prices") || "All prices"
                : `${filters.currency || "€"}${formatPrice(priceRange[0])} - ${
                    filters.currency || "€"
                  }${formatPrice(priceRange[1])}`}
            </span>
          </MenuButton>
          <Portal>
            <MenuList
              className="menu-list"
              zIndex={99999999999999}
              position="fixed"
              width="auto"
              minWidth="280px"
              padding="16px"
              style={{
                transform: "translateZ(0)",
                backgroundColor: "#1D1726",
                border: "1px solid #80737a",
                color: "white",
                borderRadius: "10px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
              }}
            >
              <Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb="12px"
                >
                  <Text fontWeight="bold" fontSize="14px" color="#AD7AEF">
                    {t("price_range") || "Price Range"}
                  </Text>

                  {/* Currency Selector */}
                  <Box>
                    <select
                      value={filters.currency || "€"}
                      onChange={(e) =>
                        updateFilters(e.target.value, "currency")
                      }
                      className="bg-[#3A2D4C] px-8px py-4px border-none rounded-md text-white text-sm"
                    >
                      <option value="€">EUR (€)</option>
                      <option value="£">GBP (£)</option>
                      <option value="Rp">IDR (Rp)</option>
                    </select>
                  </Box>
                </Box>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  mb="16px"
                  mt="8px"
                >
                  <Box
                    bg="#3A2D4C"
                    px="12px"
                    py="4px"
                    borderRadius="6px"
                    display="flex"
                    alignItems="center"
                  >
                    <Text fontWeight="bold" fontSize="14px">
                      {filters.currency || "€"}
                      {formatPrice(priceRange[0])}
                    </Text>
                  </Box>
                  <Box
                    bg="#3A2D4C"
                    px="12px"
                    py="4px"
                    borderRadius="6px"
                    display="flex"
                    alignItems="center"
                  >
                    <Text fontWeight="bold" fontSize="14px">
                      {filters.currency || "€"}
                      {formatPrice(priceRange[1])}
                    </Text>
                  </Box>
                </Box>
                <RangeSlider
                  // aria-label={["min", "max"]}
                  value={priceRange}
                  min={sliderConfig.min}
                  max={sliderConfig.max}
                  step={sliderConfig.step}
                  onChange={(val) => setPriceRange(val)}
                  onChangeEnd={(val) => updateFilters(val, "priceRange")}
                >
                  <RangeSliderTrack
                    bg="#3A2D4C"
                    height="10px"
                    borderRadius="5px"
                  >
                    <RangeSliderFilledTrack bg="#AD7AEF" height="10px" />
                  </RangeSliderTrack>
                  <RangeSliderThumb
                    boxSize="16px"
                    index={0}
                    borderRadius="50%"
                    bg="#AD7AEF"
                    border="2px solid white"
                    _focus={{
                      boxShadow: "0 0 0 3px rgba(173, 122, 239, 0.6)",
                    }}
                    transform="translateY(-8px)"
                  />
                  <RangeSliderThumb
                    boxSize="16px"
                    index={1}
                    bg="#AD7AEF"
                    border="2px solid white"
                    borderRadius="50%"
                    _focus={{
                      boxShadow: "0 0 0 3px rgba(173, 122, 239, 0.6)",
                    }}
                    transform="translateY(-8px)"
                  />
                </RangeSlider>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  mt="16px"
                  fontSize="12px"
                  color="#8A7B93"
                >
                  {filters.currency === "Rp" ? (
                    <>
                      <Text>{filters.currency}0</Text>
                      <Text>{filters.currency}500k</Text>
                      <Text>{filters.currency}1M</Text>
                      <Text>{filters.currency}1.5M</Text>
                      <Text>{filters.currency}2M</Text>
                    </>
                  ) : (
                    <>
                      <Text>{filters.currency}0</Text>
                      <Text>{filters.currency}25</Text>
                      <Text>{filters.currency}50</Text>
                      <Text>{filters.currency}75</Text>
                      <Text>{filters.currency}100</Text>
                    </>
                  )}
                </Box>
              </Box>
            </MenuList>
          </Portal>
        </Menu>
      </div>

      {/* Date filter */}
      <div className="filter-date mr-5 side">
        <DateRangePicker
          onDateChange={(displayValue, dateRange) => {
            updateFilters(displayValue, "datum");
            // Store the actual date range objects for more precise filtering
            if (dateRange) {
              updateFilters(dateRange, "dateRange");
            } else {
              // If dateRange is null (all dates), remove the dateRange filter
              setFilters((prev) => {
                const newFilters = { ...prev };
                delete newFilters.dateRange;
                return newFilters;
              });
            }
          }}
          initialDateFilter={filters.datum}
        />
      </div>

      {/* Category filter */}
      <div className="filter-category mr-5 side">
        <Menu
          placement="bottom"
          strategy="fixed"
          gutter={0}
          offset={[0, 4]}
          matchWidth={true}
        >
          <MenuButton
            as={Button}
            className="bg-[#1D1726] !border-transparent !rounded-[10px] btn btn-dropdown dropdown-toggle"
            leftIcon={<img src={CategoryIcon} alt="datum" />}
            rightIcon={<img src={ArrowDownIcon} alt="arrow down" />}
          >
            <span className="selectedOption" id="button1Text">
              {filters.categorie}
            </span>
          </MenuButton>
          <Portal>
            <MenuList
              className="menu-list"
              zIndex={9999999}
              position="fixed"
              width="auto"
              minWidth="150px"
              maxWidth="250px"
              style={{
                transform: "translateZ(0)",
              }}
            >
              <MenuOptionGroup
                className=""
                defaultValue={t("all_events")}
                type="radio"
              >
                {filterMenus.categorie.map((item, index) => (
                  <MenuItemOption
                    key={index}
                    onClick={() => {
                      updateFilters(item, "categorie");
                    }}
                    value={item}
                  >
                    {item}
                  </MenuItemOption>
                ))}
              </MenuOptionGroup>
            </MenuList>
          </Portal>
        </Menu>
      </div>

      {/* Genre filter */}
      <div className="filter-genre mr-5 side">
        <Menu
          placement="bottom"
          strategy="fixed"
          gutter={0}
          offset={[0, 4]}
          matchWidth={true}
          closeOnSelect={false}
        >
          <MenuButton
            as={Button}
            className="bg-[#1D1726] !border-transparent !rounded-[10px] btn btn-dropdown dropdown-toggle"
            leftIcon={<img src={GenreIcon} alt="datum" />}
            rightIcon={<img src={ArrowDownIcon} alt="arrow down" />}
          >
            <span className="selectedOption" id="button1Text">
              {selectedGenres.length > 0
                ? `${selectedGenres.length} ${t("genres_selected")}`
                : "Genre"}
            </span>
          </MenuButton>
          <Portal>
            <MenuList
              className="menu-list menu-checkbox-list"
              zIndex={9999999}
              position="fixed"
              width="auto"
              minWidth="150px"
              maxWidth="250px"
              style={{
                transform: "translateZ(0)",
              }}
            >
              <MenuOptionGroup
                className=""
                type="checkbox"
                aria-multiselectable
                value={selectedGenres}
                onChange={(selectedItems) => genreChange(selectedItems)}
              >
                {genreList.map((item, index) => (
                  <MenuItemOption key={index} value={item}>
                    {item === "Hitjes" ? t("hits") : item}
                  </MenuItemOption>
                ))}
              </MenuOptionGroup>
            </MenuList>
          </Portal>
        </Menu>
      </div>

      {/* Age filter */}
      <div className="filter-age side">
        <Menu
          placement="bottom"
          strategy="fixed"
          gutter={0}
          offset={[0, 4]}
          matchWidth={true}
        >
          <MenuButton
            as={Button}
            className="bg-[#1D1726] !border-transparent !rounded-[10px] btn btn-dropdown dropdown-toggle"
            leftIcon={<img src={UserIcon} alt="datum" />}
            rightIcon={<img src={ArrowDownIcon} alt="arrow down" />}
          >
            <span className="selectedOption" id="button1Text">
              {filters.leeftijd}
            </span>
          </MenuButton>
          <Portal>
            <MenuList
              className="menu-list"
              zIndex={9999999}
              position="fixed"
              width="auto"
              minWidth="150px"
              maxWidth="250px"
              style={{
                transform: "translateZ(0)",
              }}
            >
              <MenuOptionGroup
                className=""
                defaultValue={t("all_ages")}
                type="radio"
              >
                {filterMenus.leeftijd.map((item, index) => (
                  <MenuItemOption
                    key={index}
                    onClick={() => {
                      updateFilters(item, "leeftijd");
                    }}
                    value={item}
                  >
                    {item}
                  </MenuItemOption>
                ))}
              </MenuOptionGroup>
            </MenuList>
          </Portal>
        </Menu>
      </div>
    </div>
  );
};

export default DiscoverEvent;
